import React = require("react");
import {StatisticsUtils} from "../Utils/statistics/StatisticsUtils";
import "./Legend.scss";
import {FormatLocaleNumber} from "../../dashboard/widgets/DashboardUtils";

interface IconSize {
    width: number;
    height: number;
}

interface IconOptions {
    show: boolean;
    iconSize?: IconSize;
}

interface LegendProps {
    items: LegendItem[];
    selectionColor?: string;
    selectedItemName: string;
    selectionKey?: string;
    onItemHover: (d, e) => any;
    onClick?: (d, e) => any;
    iconOptions?: IconOptions;
    showValues?: boolean;
    order?: string;
    singleColumn?: boolean;
    capitalize?: boolean;
}

export interface LegendItem {
    header?: any;
    footer?: any;
    afterName?: any;
    color: string;
    name: string;
    value: number;
    percentage?: number;
    code?: string; // FIXME : viene usata nel marketing
    icon?: string;

}

export class Legend extends React.Component<LegendProps, {}> {

    public static DEFAULT_COLOR = "var(--grey-10)";

    constructor(props: LegendProps) {
        super(props);
        this.mouseOut = this.mouseOut.bind(this);
        this.mouseOver = this.mouseOver.bind(this);
    }

    public mouseOver(d: string, e) {
        this.props.onItemHover(d, e);
    }

    public mouseOut(e) {
        this.props.onItemHover(null, e);
    }

    public render() {
        let items = this.props.items;
        if (this.props.order !== undefined) {
            items = items.sort(
                (a, b) => {
                    return StatisticsUtils.dataComparator(this.props.order, a, b, "value", "order");
                },
            );
        }
        let leftItems = items;
        let rightItems = [];
        if (!this.props.singleColumn) {
            leftItems = items.slice(0, items.length / 2 + items.length % 2);
            rightItems = items.slice(items.length / 2 + items.length % 2);
        }
        const getLiElement = (item: LegendItem) => {
            const showIcon = (this.props.iconOptions !== undefined && this.props.iconOptions.show);
            const colorElement = <div className="legend-element-color" style={{backgroundColor: item.color}}/>;
            const colorElementContainer = <div
                className={"legend-element-color__container" + (showIcon ? "--with-icon" : "")}
            >
                {colorElement}
            </div>;
            // tslint:disable-next-line:no-this-assignment variable-name
            const _ref = this;
            const selectionKey = _ref.props.selectionKey === undefined ? "name" : this.props.selectionKey;
            let valueText = FormatLocaleNumber(item.value);
            if (item.percentage !== undefined) {
                if (item.percentage < 0.1 && item.percentage > 0) {
                    valueText += "( < 0.1%)";
                } else {
                    valueText += " (" + FormatLocaleNumber(item.percentage, {toFixed: 1}) + "%)";
                }
            }

            const onMouseOver = (e) => {
                const key = item[selectionKey];
                this.mouseOver(key, e);
            };
            const onClick = (e) => {
                this.props.onClick(item[selectionKey], e);
            };

            const onMouseOut = (e) => {
                this.mouseOut(e);
            };

            return <li
                className={(showIcon ? " with-icon" : "")}
                key={"li-" + item.name}
                onMouseOver={onMouseOver}
                onClick={onClick}
                onMouseOut={onMouseOut}
                style={{
                    ...this.props.selectedItemName !== null
                    && this.props.selectedItemName === item[selectionKey] ?
                        {
                            backgroundColor: (
                                this.props.selectionColor === undefined ?
                                    Legend.DEFAULT_COLOR :
                                    this.props.selectionColor
                            ),
                            borderRadius: "4px",
                        } : null,
                }}
            >
                {item.header}
                <div
                    className={"legend-list-item-body"}
                >
                    {showIcon ? colorElementContainer : colorElement}
                    {(showIcon && item.icon !== undefined && item.icon !== null) && (
                        <img
                            className={"legend__icon"}
                            src={item.icon}
                        />
                    )
                    }
                    <span className={"legend__name" + (showIcon ? " with-icon" : "")} title={item.name}>
                        <div className={"legend__name_text" + (this.props.capitalize ? " capitalize" : "")}>
                            {
                                this.props.capitalize
                                    ? item.name.toLowerCase()
                                    : item.name
                            }</div>
                        {item.afterName}
                    </span>
                    {this.props.showValues && (<span
                        className={"legend__value" + (showIcon ? " with-icon" : "")}
                        title={valueText}
                    >{valueText}</span>)}
                </div>
                {item.footer}
            </li>;
        };
        return <div className="legend__container">
            <div className={this.props.singleColumn ? "legend__container--single-column" : "legend__container--left"}>
                <ul className="legend">
                    {
                        leftItems
                            ?.map((item: LegendItem) =>
                                getLiElement(item),
                            )
                    }
                </ul>
            </div>
            {!this.props.singleColumn &&
                <div className="legend__container--right">
                    <ul className="legend">
                        {
                            rightItems
                                ?.map((item: LegendItem) =>
                                    getLiElement(item),
                                )
                        }
                    </ul>

                </div>
            }
        </div>;
    }
}

interface LegendLiElementProps {
    item: LegendItem;
    iconOptions: IconOptions;
    selectionKey?: string;
    onClick?: (d, e) => any;
    showValues?: boolean;
    selectionColor?: string;
    liStyle?: React.CSSProperties;
    onHover?: (d, e) => any;
    capitalize?: boolean;
}

interface LegendLiElementState {
    hovered: boolean;
}

export class LegendLiElement extends React.Component<LegendLiElementProps, LegendLiElementState> {

    constructor(props) {
        super(props);
        this.state = {hovered: false};
    }


    public render() {
        const showIcon = (this.props.iconOptions !== undefined && this.props.iconOptions.show);
        const colorElement = <div className="legend-element-color" style={{backgroundColor: this.props.item.color}}/>;
        const colorElementContainer = <div
            className={"legend-element-color__container" + (showIcon ? "--with-icon" : "")}
        >
            {colorElement}
        </div>;
        const selectionKey = this.props.selectionKey || "name";
        let valueText = "" + FormatLocaleNumber(this.props.item.value);
        if (this.props.item.percentage !== undefined) {
            if (this.props.item.percentage < 0.1 && this.props.item.percentage > 0) {
                valueText += "( < 0.1%)";
            } else {
                valueText += " (" + FormatLocaleNumber(this.props.item.percentage, {toFixed: 1}) + "%)";
            }
        }


        const onMouseOver = (e) => {
            const key = this.props.item[selectionKey];
            this.mouseIn(key, e);
        };
        const onClick = (e) => {
            this.props.onClick(this.props.item[selectionKey], e);
        };
        const onMouseOut = (e) => {
            this.mouseOut(e);
        };

        return (<li
            className={(showIcon ? " with-icon" : "")}
            key={"li-" + this.props.item.name}
            onMouseOver={onMouseOver}
            onClick={onClick}
            onMouseOut={onMouseOut}
            style={{
                ...(this.state.hovered ?
                        {
                            filter: "brightness(var(--brightness-hover-value))",
                            borderRadius: "3px",
                        } : null
                ),
                background: "var(--legend-li-background)",
                ...this.props.liStyle,
            }}
        >
            {this.props.item.header}
            <div
                className={"legend-list-item-body"}
            >
                {showIcon ? colorElementContainer : colorElement}
                {(showIcon && this.props.item.icon !== undefined && this.props.item.icon !== null) && (
                    <img
                        className={"legend__icon"}
                        src={this.props.item.icon}
                    />
                )
                }
                <span
                    className={"legend__name" + (showIcon ? " with-icon" : "")}
                    title={this.props.item.name}
                >
                    <div className={"legend__name_text" + (this.props.capitalize ? " capitalize" : "")}>
                        {
                            this.props.capitalize
                                ? this.props.item.name.toLowerCase()
                                : this.props.item.name
                        }
                    </div>
                    {this.props.item.afterName}
                </span>
                {this.props.showValues && (<span
                    className={"legend__value" + (showIcon ? " with-icon" : "")}
                    title={valueText}
                >{valueText}</span>)}
            </div>
            {this.props.item.footer}
        </li>);
    }

    private mouseIn = (key, e) => {
        if (this.props.onHover) {
            this.props.onHover(key, e);
            this.setState({hovered: true})
        }
    }

    private mouseOut = (e) => {
        this.setState({hovered: false})
    }
}